// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar .user[data-v-2d3b3528]{margin-top:0}.collapsed[data-v-2d3b3528]{transition:opacity 1s}.sidebar-wrapper .user .photo img[data-v-2d3b3528]{-o-object-fit:cover;object-fit:cover;height:100%}", ""]);
// Exports
module.exports = exports;
